import { render } from "./info.vue?vue&type=template&id=56c533a0"
import script from "./info.vue?vue&type=script&lang=js"
export * from "./info.vue?vue&type=script&lang=js"

import "./info.vue?vue&type=style&index=0&id=56c533a0&lang=css"

import exportComponent from "/home/smallred/20250930/inrunonline-website-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__